import { render, staticRenderFns } from "./xld-image.vue?vue&type=template&id=9da12ee6&scoped=true&"
import script from "./xld-image.vue?vue&type=script&lang=js&"
export * from "./xld-image.vue?vue&type=script&lang=js&"
import style0 from "./xld-image.vue?vue&type=style&index=0&id=9da12ee6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9da12ee6",
  null
  
)

export default component.exports